/**
 * The Home tab's count, on every screen (2026-09-24): how many things on the
 * To Do list need attention -- everything overdue or waiting, and whatever is
 * due within seven days. The server decides which (apps/api/src/todo/list.ts);
 * this shows its number.
 *
 * RED WHEN ANYTHING IS OVERDUE, and only then. Overdue there means a deadline
 * of the business's own -- a return, a deposit, a bill -- so red is kept for
 * the one thing that draws a penalty.
 *
 * NOTHING, RATHER THAN A ZERO. A tab reading "0" on every screen is one more
 * thing to read that says nothing. And nothing when the list has not been read
 * or could not be: SyncBanner's argument, that a count shouting about its own
 * fetch would cry wolf on every API restart. Home says why when it cannot read.
 *
 * The number is decoration to a screen reader; the sentence beside it, hidden
 * from sight, is what is read: "Home, 6 to do, 1 overdue".
 */

import { useTodo } from './TodoProvider.js';

export function TodoBadge() {
  const { todo } = useTodo();
  if (todo === null || todo.attention === 0) return null;
  const said = `${todo.attention} to do${todo.overdue > 0 ? `, ${todo.overdue} overdue` : ''}`;
  return (
    <span className={`nav-badge${todo.overdue > 0 ? ' is-overdue' : ''}`} title={said}>
      <span aria-hidden="true">{todo.attention}</span>
      <span className="visually-hidden">, {said}</span>
    </span>
  );
}
